import NotificationsNoneRoundedIcon from "@mui/icons-material/NotificationsNoneRounded";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { Box, IconButton, Typography } from "@mui/material";
import axios from "axios";
import Cookies from "js-cookie";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

function Notifications({ notification, removeNotification, handleClose }) {
  const [deleting, setDeleting] = useState(false);
  const navigate = useNavigate();
  const apiBase = process.env.React_APP_BACKEND_URL || "";

  const handleCancel = async (event) => {
    event.preventDefault();
    event.stopPropagation();
    if (deleting) return;

    setDeleting(true);
    try {
      const response = await axios.delete(
        `${apiBase}/api/deletenoti?id=${encodeURIComponent(notification.id)}`,
        { headers: { Authorization: `Bearer ${Cookies.get("token")}` } }
      );
      removeNotification(notification.id, response.data?.TotalNoti);
    } catch (error) {
      console.log(error);
      setDeleting(false);
    }
  };

  const openNotification = () => {
    handleClose();
    if (notification.bidId) navigate(`/showbid/${notification.bidId}`);
  };

  return (
    <Box role="button" tabIndex={0} onClick={openNotification} onKeyDown={(event) => event.key === "Enter" && openNotification()} sx={{ display: "flex", alignItems: "flex-start", gap: 1.2, p: 1.35, mb: 0.8, borderRadius: "14px", border: "1px solid #E4EDF5", backgroundColor: "#FFFFFF", cursor: "pointer", transition: "border-color .18s ease, transform .18s ease, box-shadow .18s ease", opacity: deleting ? 0.55 : 1, "&:hover": { borderColor: "#BCDDFC", transform: "translateY(-1px)", boxShadow: "0 8px 20px rgba(31,103,164,.08)" } }}>
      <Box sx={{ width: 38, height: 38, borderRadius: "12px", display: "grid", placeItems: "center", color: "#1677D2", backgroundColor: "#EAF5FF", flexShrink: 0 }}>
        <NotificationsNoneRoundedIcon sx={{ fontSize: 21 }} />
      </Box>
      <Typography sx={{ flex: 1, pt: 0.35, fontFamily: `${process.env.REACT_APP_FONT}`, fontWeight: 700, color: "#294B66", fontSize: "0.91rem", lineHeight: 1.55, overflowWrap: "anywhere" }}>
        {notification.notification}
      </Typography>
      <IconButton aria-label="מחיקת התראה" title="מחיקת התראה" disabled={deleting} onClick={handleCancel} size="small" sx={{ mt: -0.35, mr: -0.35, color: "#8298AA", "&:hover": { color: "#D34D4D", backgroundColor: "#FFF0F0" } }}>
        <CloseRoundedIcon sx={{ fontSize: 19 }} />
      </IconButton>
    </Box>
  );
}

export default Notifications;
